import { useState } from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/contact", form);
      toast.success(res.data.message);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Invio non riuscito. Riprova.");
    } finally {
      setBusy(false);
    }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="pt-32 pb-24 relative z-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16">
        <Reveal>
          <p className="eyebrow mb-4">Contatti</p>
          <h1 className="font-display text-4xl sm:text-6xl text-white leading-tight mb-6">Parliamone. <span className="gold-text italic">Gratis.</span></h1>
          <p className="text-zinc-400 leading-relaxed mb-10 max-w-md">Prenota il tuo primo colloquio gratuito e senza impegno, oppure scrivimi per qualsiasi domanda. Ti risponderò personalmente.</p>
          <div className="space-y-5">
            {[[Mail, "Email", "info@mirkoscravaglieri.com"], [Phone, "Telefono", "+39 000 000 0000"], [MapPin, "Dove", "Italia · Sessioni in presenza e online"]].map(([Icon, label, val], i) => (
              <div key={i} className="flex items-center gap-4">
                <div className="h-11 w-11 rounded-full bg-[#C19A5B]/15 flex items-center justify-center text-[#C19A5B]"><Icon size={18} /></div>
                <div>
                  <p className="text-zinc-500 text-xs uppercase tracking-wider">{label}</p>
                  <p className="text-white">{val}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <form onSubmit={submit} data-testid="contact-form" className="bg-[#121212] border border-white/10 rounded-2xl p-8 space-y-5">
            <div>
              <label className="text-sm text-zinc-400 mb-2 block">Nome</label>
              <input value={form.name} onChange={upd("name")} required data-testid="contact-name" className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-4 py-3 outline-none focus:border-[#C19A5B]" />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-zinc-400 mb-2 block">Email</label>
                <input type="email" value={form.email} onChange={upd("email")} required data-testid="contact-email" className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-4 py-3 outline-none focus:border-[#C19A5B]" />
              </div>
              <div>
                <label className="text-sm text-zinc-400 mb-2 block">Telefono</label>
                <input value={form.phone} onChange={upd("phone")} data-testid="contact-phone" className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-4 py-3 outline-none focus:border-[#C19A5B]" />
              </div>
            </div>
            <div>
              <label className="text-sm text-zinc-400 mb-2 block">Messaggio</label>
              <textarea value={form.message} onChange={upd("message")} required rows={5} data-testid="contact-message" className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-4 py-3 outline-none focus:border-[#C19A5B] resize-none" />
            </div>
            <button type="submit" disabled={busy} data-testid="contact-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#C19A5B] text-black font-semibold px-6 py-3.5 hover:bg-[#D4AF37] transition-colors disabled:opacity-60">
              {busy ? "Invio…" : <>Invia messaggio <Send size={16} /></>}
            </button>
          </form>
        </Reveal>
      </div>
    </div>
  );
};

export default Contact;
